import { useState } from "react";
import { toast } from "sonner";
import { ImagePlus, X } from "lucide-react";
import { api, BACKEND_URL, formatApiErrorDetail } from "@/lib/api";

export function LogoUpload({ value, onChange }) {
  const [busy, setBusy] = useState(false);

  const upload = async (e) => {
    const f = e.target.files?.[0];
    if (!f) return;
    if (f.size > 2 * 1024 * 1024) return toast.error("Logo must be under 2MB");
    setBusy(true);
    try {
      const fd = new FormData();
      fd.append("logo", f);
      const { data } = await api.post("/admin/jobs/logo", fd, { headers: { "Content-Type": "multipart/form-data" } });
      onChange(data.path);
      toast.success("Logo uploaded");
    } catch (err) { toast.error(formatApiErrorDetail(err.response?.data?.detail)); }
    finally { setBusy(false); e.target.value = ""; }
  };

  return (
    <div className="flex items-center gap-4">
      <div className="w-16 h-16 rounded-xl border border-slate-200 bg-slate-50 flex items-center justify-center overflow-hidden shrink-0">
        {value ? <img data-testid="logo-preview" src={`${BACKEND_URL}/api/logos/${value}`} alt="logo" className="w-full h-full object-contain" /> : <ImagePlus size={20} className="text-slate-400" />}
      </div>
      <div className="flex items-center gap-2">
        <label className="inline-flex items-center px-4 h-9 rounded-full border border-slate-200 text-sm font-medium cursor-pointer hover:bg-slate-50">
          {busy ? "Uploading…" : value ? "Replace logo" : "Upload logo"}
          <input data-testid="job-logo-input" type="file" accept="image/png,image/jpeg,image/webp,image/svg+xml" className="hidden" onChange={upload} disabled={busy} />
        </label>
        {value && (
          <button type="button" data-testid="job-logo-remove" onClick={() => onChange(null)} className="text-slate-400 hover:text-rose-600"><X size={16} /></button>
        )}
      </div>
    </div>
  );
}
